module.exports = {
    NODE_ENV: '"production"',
    BASE_API: '""',
    APP_ORIGIN: '"https://agent.fei-wang.com.tw"'
};



//////////////////
// WEBPACK FOOTER
// ./config/prod.env.js
// module id = 201
// module chunks = 103